import { getTokenLocal } from "../utils/localStorage.util";
import ApiRoutes from "../conffigs/endpoints.config";
import HttpClient from "./index.api";
const baseURL = process.env.REACT_APP_API_URL;

class Dashboard extends HttpClient {
  constructor() {
    super(baseURL);
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${getTokenLocal()}`;
      return config;
    });
  };

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (response) => {
        return Promise.resolve(response);
      }
    );
  };

  DashboardConfig = ApiRoutes.Dashboard.Data;
  InchargeConfig = ApiRoutes.Dashboard.Incharge;
  FranchiseConfig = ApiRoutes.Dashboard.Franchise;
  StaffDetailConfig = ApiRoutes.Dashboard.staffDetail;
  GraminNotificationConfig = ApiRoutes.Dashboard.getNotification;
  NotificationReadConfig = ApiRoutes.Dashboard.readNotification;

  notificationRead = async () => {
    return this.instance({
      method: this.NotificationReadConfig.Method,
      url: this.NotificationReadConfig.Endpoint,
      headers: {},
      data: null,
    });
  };
  getNotification = async () => {
    return this.instance({
      method: this.GraminNotificationConfig.Method,
      url: this.GraminNotificationConfig.Endpoint,
      headers: {},
      data: null,
    });
  };
  getStaffDetail = async () => {
    return this.instance({
      method: this.StaffDetailConfig.Method,
      url: this.StaffDetailConfig.Endpoint,
      headers: {},
      data: null,
    });
  };
  getDashboard = async (data) => {
    return this.instance({
      method: this.DashboardConfig.Method,
      url: this.DashboardConfig.Endpoint,
      headers: {},
      params: data,
      data: data,
    });
  };
  getInchargeDashboard = async (data) => {
    return this.instance({
      method: this.InchargeConfig.Method,
      url: this.InchargeConfig.Endpoint,
      headers: {},
      params: data,
      data: data,
    });
  };
  getFranchiseDashboard = async (data) => {
    return this.instance({
      method: this.FranchiseConfig.Method,
      url: this.FranchiseConfig.Endpoint,
      headers: {},
      params: data,
      data: data,
    });
  };

}

export default Dashboard;
